/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Message_DeletedInputs */

const en_message_deleted = /** @type {(inputs: Message_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message deleted by moderator`)
};

const id_message_deleted = /** @type {(inputs: Message_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan dihapus oleh moderator`)
};

/** @type {(inputs: Message_DeletedInputs) => LocalizedString} */
const es_message_deleted = en_message_deleted;

/** @type {(inputs: Message_DeletedInputs) => LocalizedString} */
const fr_message_deleted = en_message_deleted;

/** @type {(inputs: Message_DeletedInputs) => LocalizedString} */
const de_message_deleted = en_message_deleted;

/** @type {(inputs: Message_DeletedInputs) => LocalizedString} */
const ja_message_deleted = en_message_deleted;

/** @type {(inputs: Message_DeletedInputs) => LocalizedString} */
const zh_message_deleted = en_message_deleted;

/** @type {(inputs: Message_DeletedInputs) => LocalizedString} */
const ar_message_deleted = en_message_deleted;

/** @type {(inputs: Message_DeletedInputs) => LocalizedString} */
const it_message_deleted = en_message_deleted;

/** @type {(inputs: Message_DeletedInputs) => LocalizedString} */
const ru_message_deleted = en_message_deleted;

/** @type {(inputs: Message_DeletedInputs) => LocalizedString} */
const pt_message_deleted = en_message_deleted;

/** @type {(inputs: Message_DeletedInputs) => LocalizedString} */
const ko_message_deleted = en_message_deleted;

/**
* | output |
* | --- |
* | "Message deleted by moderator" |
*
* @param {Message_DeletedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const message_deleted = /** @type {((inputs?: Message_DeletedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Message_DeletedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_message_deleted(inputs)
	if (locale === "es") return es_message_deleted(inputs)
	if (locale === "fr") return fr_message_deleted(inputs)
	if (locale === "de") return de_message_deleted(inputs)
	if (locale === "ja") return ja_message_deleted(inputs)
	if (locale === "zh") return zh_message_deleted(inputs)
	if (locale === "ar") return ar_message_deleted(inputs)
	if (locale === "id") return id_message_deleted(inputs)
	if (locale === "it") return it_message_deleted(inputs)
	if (locale === "ru") return ru_message_deleted(inputs)
	if (locale === "pt") return pt_message_deleted(inputs)
	return ko_message_deleted(inputs)
});